import React from 'react'
import { func } from 'prop-types'
import ReCAPTCHA from 'react-google-recaptcha'

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY
  ? process.env.REACT_APP_RECAPTCHA_SITE_KEY
  : process.env.STORYBOOK_RECAPTCHA_SITE_KEY

export function Captcha({ setRef, returnCaptcha, ...rest }) {
  return <ReCAPTCHA ref={setRef} sitekey={SITE_KEY} onChange={returnCaptcha} />
}

Captcha.propTypes = {
  setRef: func,
  returnCaptcha: func,
}
